import ArchiveIcon from "@material-ui/icons/Archive";
import EditIcon from "@material-ui/icons/Edit";
import UnarchiveIcon from "@material-ui/icons/Unarchive";
import VisibilityIcon from "@material-ui/icons/Visibility";

import Table from "src/components/Table";
import { listVanIntegrations_listVanIntegrations } from "src/graphql/generated/listVanIntegrations";

export default function IntegrationTable({
  rows,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  totalCount,
  handleDelete,
  handleUndelete,
  handleEdit,
  handleView
}: {
  rows: listVanIntegrations_listVanIntegrations[];
  page: number;
  handleChangePage: (newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
  handleDelete: (integrationId: string) => Promise<void>;
  handleUndelete: (integrationId: string) => Promise<void>;
  handleEdit: (integration: listVanIntegrations_listVanIntegrations) => void;
  handleView: (integration: listVanIntegrations_listVanIntegrations) => void;
}): JSX.Element {
  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Name",
          renderValue: integration => integration.name
        },
        {
          key: "type",
          title: "Type",
          renderValue: () => "NGP VAN / EveryAction"
        },
        {
          key: "createdAt",
          title: "Created At",
          renderValue: integration =>
            new Date(integration.createdAt).toLocaleString()
        }
      ]}
      rows={rows}
      rowActions={integration => [
        {
          icon: <VisibilityIcon />,
          tooltipLabel: "Details",
          onClick: () => handleView(integration)
        },
        {
          icon: <EditIcon />,
          tooltipLabel: "Edit",
          onClick: () => handleEdit(integration)
        },
        integration.deletedAt
          ? {
              icon: <UnarchiveIcon />,
              tooltipLabel: "Unarchive",
              onClick: () => handleUndelete(integration.id)
            }
          : {
              icon: <ArchiveIcon />,
              tooltipLabel: "Archive",
              onClick: () => handleDelete(integration.id),
              confirm: {
                title: "Archive Integration",
                description: (
                  <div>
                    <p>
                      Are you sure you want to archive the integration "
                      {integration.name}"?
                    </p>
                    <p>
                      Campaigns currently using this integration will continue
                      to sync to VAN but you won't be able to select this
                      integration for new campaigns. If you want to stop
                      existing campaigns from syncing to VAN, you'll need to
                      remove this integration from each of those campaigns
                      individually.
                    </p>
                  </div>
                )
              }
            }
      ]}
      emptyState="No integrations found"
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      onChangePage={handleChangePage}
    />
  );
}
